const NotAuthorized = () => (
    <div style={{ padding: 40, textAlign: 'center' }}>
        <h2>Unauthorized</h2>
        <p>You don't have permission to view this page.</p>
    </div>
);

export default NotAuthorized;
